export const IntroSnackbar = () => {
  return <></>
}
